import axios, { AxiosPromise, Canceler, CancelTokenStatic } from 'axios';
import { ICapital } from '../../../@types/model/masterData/capital/capital';
import { ICapitalUpsert } from '../../../@types/model/masterData/capital/capitalUpsert';

export default class CapitalHttpService {
    private static readonly CancelToken : CancelTokenStatic = axios.CancelToken;
    /**
     * Allows you to cancel list request
     */
    public static cancelGetList ?: Canceler;

    public static getList(departmentIds : Array<number>) : AxiosPromise<Array<ICapital>> {
        if (this.cancelGetList) {
            this.cancelGetList('GET Canceled');
            this.cancelGetList = undefined;
        }

        return axios.get(`${API_URL}/v1/MasterData/capital/GetList`, {
            params: {
                departmentIds
            },
            cancelToken: new this.CancelToken((c) => {
                this.cancelGetList = c;
            }),
        });
    }

    public static upsert = (upsert : ICapitalUpsert, type : 'Add' | 'Edit') : AxiosPromise<ICapital> => {
        return axios.post(`${API_URL}/v1/MasterData/capital/${type}`, upsert);
    }

    public static delete = (id : number) : AxiosPromise => {
        return axios.delete(`${API_URL}/v1/MasterData/capital/Delete`, {
            params: { id },
        });
    }
}